import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Spot Free Clarity</h1>
          <p>Your trusted window cleaning partner in Somerset West</p>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content">
        <div className="container">
          <div className="about-section">
            <h2>Our Story</h2>
            <p>
              Spot Free Clarity started with a simple mission: to provide exceptional window
              cleaning services to the Somerset West community. What began as a small operation
              has grown into a trusted local business known for reliability, quality, and
              outstanding customer service.
            </p>
            <p>
              We believe that clean windows are more than just aesthetics - they're about
              maintaining your property, improving its appearance, and creating a fresh,
              welcoming environment for both homes and businesses.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Mission</h2>
            <p>
              To deliver professional, high-quality window cleaning services that exceed
              customer expectations while maintaining the highest standards of safety,
              reliability, and customer care in Somerset West and surrounding areas.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Quality</h3>
                <p>We never compromise on the quality of our work. Every window gets
                  the attention it deserves.</p>
              </div>
              <div className="value-card">
                <h3>Reliability</h3>
                <p>You can count on us to show up on time and deliver exactly what
                  we promise.</p>
              </div>
              <div className="value-card">
                <h3>Professionalism</h3>
                <p>Our team is trained, uniformed, and committed to professional conduct
                  at all times.</p>
              </div>
              <div className="value-card">
                <h3>Customer Focus</h3>
                <p>Your satisfaction is our priority. We listen to your needs and deliver
                  accordingly.</p>
              </div>
              <div className="value-card">
                <h3>Safety</h3>
                <p>We prioritize safety for our team and your property in every job we undertake.</p>
              </div>
              <div className="value-card">
                <h3>Sustainability</h3>
                <p>We use environmentally responsible cleaning methods wherever possible.</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Why Somerset West Trusts Us</h2>
            <p>
              We've built our reputation through years of consistent service, attention to detail,
              and genuine care for our customers. Whether it's residential homes or commercial
              properties, we treat every job with the same level of professionalism and care.
            </p>
            <p>
              Our local presence means we understand the unique needs of Somerset West's climate
              and properties. We're not just a service provider - we're your neighbors committed
              to keeping our community looking its best.
            </p>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2 style={{ textAlign: 'center', color: 'var(--text-dark)' }}>Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>👔</div>
              <h3>Experienced Management</h3>
              <p>Our team is led by experienced professionals with years of industry expertise
                and a passion for excellence.</p>
            </div>
            <div className="team-member">
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>👷</div>
              <h3>Trained Technicians</h3>
              <p>Every member of our cleaning team is thoroughly trained in safety protocols,
                cleaning techniques, and customer service.</p>
            </div>
            <div className="team-member">
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>💬</div>
              <h3>Customer Support</h3>
              <p>Our dedicated support team is ready to answer your questions and help
                schedule your service at your convenience.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
